
import React from "react";
import { useState } from 'react';
import pageData from "../PageData";
const logout =()=>{ 

//const [imgUrl,setImageUrl] = useState("/assets/images/usersImage/28.jpg");
//const [userName, setUserName] = useState("Naveen"); 
return (
 <>
		    Log Out
		</>

);
}
export default logout;